import { useParams } from 'react-router-dom';
import ChatRoom from '../components/Chat/ChatRoom';

export default function ChatPage() {
  const { matchId } = useParams();

  return <ChatRoom matchId={matchId} />;
}
